import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// Auth Store
export const useAuthStore = create(
  persist(
    (set) => ({
      token: null,
      user: null,
      isAuthenticated: false,
      
      login: (token, user) => set({ 
        token, 
        user, 
        isAuthenticated: true 
      }),
      
      logout: () => {
        localStorage.removeItem('4sat_token');
        localStorage.removeItem('4sat_user');
        set({ token: null, user: null, isAuthenticated: false });
      },
      
      setUser: (user) => set({ user }),
    }),
    {
      name: '4sat-auth',
      partialize: (state) => ({ token: state.token, user: state.user, isAuthenticated: state.isAuthenticated }),
    }
  )
);

// Devices Store
export const useDevicesStore = create((set, get) => ({
  devices: [],
  selectedDevice: null,
  loading: false,
  error: null,
  
  setDevices: (devices) => set({ devices }),
  
  setSelectedDevice: (device) => set({ selectedDevice: device }),
  
  updateDeviceLocation: (imei, location) => {
    const devices = get().devices.map(d => 
      d.imei === imei ? { ...d, ...location } : d
    );
    set({ devices });
  },
  
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
}));

// UI Store
export const useUIStore = create(
  persist(
    (set) => ({
      sidebarCollapsed: false,
      activeTab: 'map',
      theme: 'dark',
      
      toggleSidebar: () => set((state) => ({ sidebarCollapsed: !state.sidebarCollapsed })),
      setSidebarCollapsed: (collapsed) => set({ sidebarCollapsed: collapsed }),
      setActiveTab: (tab) => set({ activeTab: tab }),
      setTheme: (theme) => set({ theme }),
    }),
    {
      name: '4sat-ui',
    }
  )
);

// Brand Settings Store
export const useBrandStore = create(
  persist(
    (set) => ({
      logoUrl: null,
      companyName: '4Sat',
      primaryColor: '#3b82f6',
      secondaryColor: '#10b981',
      loginLogoSize: 'medium', // small, medium, large
      
      setLogoUrl: (logoUrl) => set({ logoUrl }),
      setCompanyName: (companyName) => set({ companyName }),
      setPrimaryColor: (primaryColor) => set({ primaryColor }),
      setSecondaryColor: (secondaryColor) => set({ secondaryColor }),
      setLoginLogoSize: (loginLogoSize) => set({ loginLogoSize }),
      setBrandSettings: (settings) => set(settings),
    }),
    {
      name: '4sat-brand',
    }
  )
);

// Alerts Store
export const useAlertsStore = create((set, get) => ({
  alerts: [],
  unreadCount: 0,
  
  setAlerts: (alerts) => set({ alerts, unreadCount: alerts.filter(a => !a.read).length }),
  
  addAlert: (alert) => {
    const alerts = [alert, ...get().alerts];
    set({ alerts, unreadCount: get().unreadCount + 1 });
  },
  
  markAsRead: (alertId) => {
    const alerts = get().alerts.map(a => 
      a.id === alertId ? { ...a, read: true } : a
    );
    set({ alerts, unreadCount: alerts.filter(a => !a.read).length });
  },
  
  clearAlerts: () => set({ alerts: [], unreadCount: 0 }),
}));
